export function emailSecretIsValid({
  emailaddress,
  secret,
}: {
  emailaddress: string;
  secret: string;
}) {
  return secret === makeEmailSecret(emailaddress);
}

export function makeEmailSecret(emailAddress: string): string {
  return emailAddress
    .split("")
    .reduce((sum, char) => sum + char.charCodeAt(0), 0)
    .toString();
}
